export default {
	"um.new.user": "Nouvel utilisateur",
	"um.user.name": "Nom d'utilisateur",
	"um.phone.number": "Numéro de téléphone",
	"um.email": "Email",
	"um.admin": "Admin",
	"um.normal": "Ordinaire",
	"um.password": "Mot de passe ",
	"um.confirmPassword": "Confirmez le mot de passe",
	"um.role": "Rôle",
	"um.modify.user": "Modifier l'utilisateur",
	"um.add.user.success": "Utilisateur ajouté avec succès",
	"um.edit.user.success": "Utilisateur modifié avec succès",
	"um.digut.number": "569 + numéro à 8 chiffres",
	"um.delete.user.success": "Supprimer l'utilisateur avec succès",
	"um.delete.user.sure": "Êtes-vous sûr de vouloir supprimer cet utilisateur",
	"um.total": "Total",
	"um.items": "Articles",
	"um.select": "Sélectionner",
	"um.acct": "Compte",
	"um.unblock.user.sure": "Êtes-vous sûr de débloquer cet utilisateur?",
	"um.block.user.sure": "Êtes-vous sûr de bloquer cet utilisateur",
	"um.unblock.user.success": "Êtes-vous sûr de débloquer cet utilisateur",
	"um.block.user.success": "Utilisateur bloqué avec succès",
	"um.block": "Bloquer",
	"um.unblock": "Débloquer",
	"um.user.name.rule": "Seulement 6 à 100 chiffres, lettres et caractères @ _-. Combinaison",
	"um.customer.admin": "Client administrateur",
	"um.department.admin": "Administrateur du département ",
	"um.user": "Utilisateur",
	"um.user.id": "Identifiant d'utilisateur",
	"um.confirm.password": "Confirmez le mot de passe",
	"um.department": "Département",
	"um.super.admin": "Super Admin",
	"um.bcare.admin": "Bcare Admin"
}